













































import {
    TyMarketplace
} from '@/classes/TayehApi';
import {
    GetMarketplaceShopProductResponse
} from '@/classes/TayehApi/TyMarketplace';
import {
    Component,
  Prop,
    Vue,
    Watch
} from 'vue-property-decorator';
import MarketplaceProduct from '../MarketplaceProduct/MarketplaceProduct.vue';
import InfiniteLoading from 'vue-infinite-loading';
@Component({
    components: {
        MarketplaceProduct,
        InfiniteLoading
    }
})
export default class MarketplaceShopProfileProducts extends Vue {
    @Prop({default: ''}) search: string;
    @Prop() categoryId: string;
    private sort = 'fresh';
    private shop_sorts = [
        {name: 'تازه‌ترین', query: 'fresh'},
        {name: 'ارزان‌ترین', query: 'price_low_2_high'},
        {name: 'گران‌ترین', query: 'price_high_2_low'},
    ];
    private products: GetMarketplaceShopProductResponse[] = [];
    private count: number;
    private skeleton_array = new Array(9);
    private page = 0;

    @Watch('search')
    @Watch('categoryId')
    @Watch('sort')
    searchInProducts () {
        this.page = 0;
        this.products = [];
        this.getShopProducts();
    }

    async getShopProducts($state?: any) {
        const res = await TyMarketplace.getTyMarketplaceShopProducts(this.$route.params.shop_username, {
            sort: this.sort,
            page: this.page,
            search: this.search.trim(),
            category_id: this.categoryId
        });
        this.page++;
        const new_products = res.data.products
        this.products = [...this.products, ...new_products];
        if ($state) {
            $state.loaded();
            if (new_products.length===0) $state.complete();
        }
    }

    mounted() {
        this.getShopProducts()
    }
}
